// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage, intlShape } from 'react-intl';
import { Redirect, Route, Switch } from 'react-router';
import { Link } from 'react-router-dom';
import Banner from '../../../elements/Banner/Banner';
import OrdersRequestsContainer from '../containers/OrdersRequestsContainer';
import FlightSalesContainer from '../containers/FlightSalesContainer';
import moment from 'moment/moment';
import routes from '../../../routes';
// import { Default } from '../../../utils/responsive/index';
import { getLocalizedCountry } from '../../local-values/utils/countries';
import Page from '../../../Page';

import style from './Flight.scss';
import subNavStyle from '../../../assets/styles/sub-nav.scss';
import icons from '../../../assets/styles/icons.scss';

import type { LocalValuesState } from '../../local-values/duck';
import type { Location, Match } from '../../../router';
import type { HTTPError } from '../../../error';
import type { Flight as FlightType } from '../../../entities';

type Props = {
  +location: Location;
  +match: Match;
  +localValues: LocalValuesState;
  +isFetchingFlight?: boolean;
  +flight?: FlightType;
  +fetchFlightError?: HTTPError;
  +fetchFlight: (id: string) => void;
  +resetFlightState: () => void;
};

export default class Flight extends Component<Props, void> {
  urlIdFlight: string;

  constructor(props: Props) {
    super(props);
    if (props.match.params) this.urlIdFlight = props.match.params.id;
  }

  componentDidMount() {
    const { fetchFlight, flight } = this.props;
    if (!flight) {
      fetchFlight(this.urlIdFlight);
    }
  }

  componentWillUnmount() {
    const { resetFlightState } = this.props;
    resetFlightState();
  }

  /*formatFlightTitle = (flight: FlightType, formatMessage: (value: { [id: string]: string }) => string): string => {
    const { localValues } = this.props;
    let l, r;
    if (flight.departureAdmin2)
      l = flight.departureAdmin2.name;
    else if (flight.departureAdmin1)
      l = flight.departureAdmin1.name;
    else
      l = getLocalizedCountry(flight.departureCountry.code, formatMessage, localValues.countriesMap);

    if (flight.arrivalAdmin2)
      r = flight.arrivalAdmin2.name;
    else if (flight.arrivalAdmin1)
      r = flight.arrivalAdmin1.name;
    else
      r = getLocalizedCountry(flight.arrivalCountry.code, formatMessage, localValues.countriesMap);

    return `${l} - ${r}`;
  };*/

  render() {
    const { location, flight } = this.props;
    const subRoute = location.pathname.split('/')[3];
    const rightElement = flight &&
      <p>
        <i className={icons.iconCalendarMedium}/>
        {moment(flight.flightDate).utc().format('MMMM DD, YYYY', { trim: false })}
      </p>;
    return (
      <section className={style.flightWrap}>
        <Banner
          titleElement={<FormattedMessage id="banner.back">{
            txt => <h1>
              <Link to="/flights/current"><i className={icons.iconChevronLeftMedium}/>{txt}</Link>
            </h1>
          }</FormattedMessage>}
          rightElement={rightElement}
          color="orange"/>
        <nav className={classNames(subNavStyle.subNav, subNavStyle.orange)}>
          <section>
            <ul>
              <li className={classNames({ [subNavStyle.active]: subRoute === 'requests' })}>
                <FormattedMessage id="flight.nav.requests">{
                  txt => (<Link to={`/flight/${this.urlIdFlight}/requests`}>{txt}</Link>)
                }</FormattedMessage>
              </li>
              <li className={classNames({ [subNavStyle.active]: subRoute === 'sales' })}>
                <FormattedMessage id="flight.nav.sales">{
                  txt => (<Link to={`/flight/${this.urlIdFlight}/sales`}>{txt}</Link>)
                }</FormattedMessage>
              </li>
            </ul>
          </section>
        </nav>
        <Switch>
          <Route exact path={routes.FLIGHT.children.REQUESTS.routePath}
                 render={props => <Page name={routes.FLIGHT.children.REQUESTS.name}>
                   <OrdersRequestsContainer {...props}/>
                 </Page>}/>
          <Route exact path={routes.FLIGHT.children.SALES.routePath}
                 render={props => <Page name={routes.FLIGHT.children.SALES.name}>
                   <FlightSalesContainer {...props}/>
                 </Page>}/>
          <Redirect from={routes.FLIGHT.routePath}
                    to={routes.FLIGHT.children.REQUESTS.routePath.replace(':id', this.urlIdFlight)}/>
        </Switch>
      </section>
    );
  }
}

Flight.propTypes = {
  location: PropTypes.object.isRequired,
  localValues: PropTypes.object,
  flight: PropTypes.object,
  fetchFlight: PropTypes.func.isRequired,
  resetFlightState: PropTypes.func.isRequired,
};

Flight.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/flight/components/Flight.jsx